import { VehicleTypeEnum } from '../generated/graphqlV2';

export default function getVehicleImage(
  type: VehicleTypeEnum | string,
  variant: 'default' = 'default',
): string {
  return `${process.env.PUBLIC_URL}/images/vehicles/vehicles-icons/${type}-${variant}.png`;
}
